import * as Constants from "../../Constants/constants";

export async function SessionCheck(){
    try {
        const response = await fetch(
            Constants.StartSimulationConstants.ENDPOINT_SESSIONCHECK,
            Constants.CommonConstants.DEFAULT_GET_REQUEST_OPTIONS
        )
        const result = await response.json();
        if (result.success == false) {
            console.log("Sessão inexiste/expirada.");
            return false;
        }
        return true;
    }
    catch (error) {
        console.log(error);
        return false;
    }
}

export async function ClearSession(){
    try {
        const response = await fetch(
            Constants.StartSimulationConstants.ENDPOINT_CLEARSESSION,
            Constants.CommonConstants.DEFAULT_GET_REQUEST_OPTIONS
        )
        const result = await response.json();
        if (result.success == false) {
            console.log("Problemas ao limpar a sessão:"+result.technicalMessage);
            return false;
        }
        return true;
    }
    catch (error) {
        console.log(error);
        return false;
    }
}